export default __webpack_public_path__ + "static/media/skill.63a58034.svg";